import { faStore } from '@fortawesome/pro-regular-svg-icons/faStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/V3/Button/Button';
import { Dropdown, DropdownContent, DropdownTrigger } from 'components/UI/V3/Dropdown';
import { DropdownItem } from 'components/UI/V3/Dropdown/Item/DropdownItem';
import { FunctionComponent, useState } from 'react';
import styles from './IdogcamLocationFilter.module.scss';

export interface IdogcamLocationOption {
    id: number;
    name: string;
}

interface IdogcamLocationFilterProps {
    locations: Array<IdogcamLocationOption>;
    selectedLocationId: number;
    onChange: (locationId: number) => void;
}

// Single-location picker (iDogCam works on one location at a time). Same pattern as the Tasks
// dashboard "times" filter: popover on desktop, V3 MobileBottomModal sheet on mobile.
export const IdogcamLocationFilter: FunctionComponent<IdogcamLocationFilterProps> = props => {
    const [open, setOpen] = useState(false);

    if (props.locations.length <= 1) {
        return null;
    }

    const selectedLocation = props.locations.find(location => location.id === props.selectedLocationId);

    return (
        <Dropdown
            open={open}
            onOpenChange={setOpen}
        >
            <DropdownTrigger>
                <Button
                    className={styles.button}
                    variant="outlined"
                    size="large"
                    leftIcon={faStore}
                    label={selectedLocation?.name ?? 'Select location'}
                />
                <div
                    className={styles.mobileButton}
                    aria-label="Select location"
                >
                    <FontAwesomeIcon icon={faStore} />
                </div>
            </DropdownTrigger>
            <DropdownContent
                minWidth={240}
                align="end"
            >
                <p className={styles.title}>Location</p>
                {props.locations.map(location => (
                    <DropdownItem
                        key={location.id}
                        type="radio"
                        checked={location.id === props.selectedLocationId}
                        className={styles.item}
                        onSelect={() => props.onChange(location.id)}
                    >
                        {location.name}
                    </DropdownItem>
                ))}
            </DropdownContent>
        </Dropdown>
    );
};

export default IdogcamLocationFilter;
